import {createContext} from 'react'

export const OperatorChartSettingsContext = createContext('')
export const OperatorChartSettingsProvider = OperatorChartSettingsContext.Provider
